module.exports = __webpack_public_path__ + "img/help-proteinanalysis-video.110faa6f.png";